<div (click)='$event.stopPropagation()' class='modal-header'>
  <h4 class='modal-title'>
    {{ "TITLE.DB_HISTORY" | translate }}
  </h4>
</div>

<div (click)='$event.stopPropagation()' class='modal-body modal-body-history'>

  <ng-container *ngIf="history.items.length > 0; then DATA else EMPTY"></ng-container>
  <ng-template #EMPTY>
    <div class="centred-text">
      <pt-icon [key]="iconEmpty" [size]="iconSize"></pt-icon>
      <div>{{ 'MESSAGE.NO_ITEMS_FOUND' | translate }}</div>
    </div>
  </ng-template>

  <ng-template #DATA>
    <table class="table">
      <thead style="position: sticky;top: -16px; background: white;">
      <tr>
        <th scope="col">{{ 'AG_GRID.HEADERS.createAt' | translate }}</th>
        <th scope="col">{{ 'AG_GRID.HEADERS.name' | translate }}</th>
        <th scope="col">{{ 'AG_GRID.HEADERS.action' | translate }}</th>
        <th scope="col">{{ 'AG_GRID.HEADERS.history_description' | translate }}</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let i of history.items">
        <td>{{ i.createdAt | localizedDate: {pattern: 'dd/MM/yyyy HH:mm', defaultValue: ND} }}</td>
        <td>{{ i.fullName }}</td>
        <td>{{ i.action }}</td>
        <td>
          <ul *ngIf="i.description?.length > 0" class="mb-0">
            <li *ngFor="let i of i.description">{{ i }}</li>
          </ul>
        </td>
      </tr>
      </tbody>
    </table>
  </ng-template>

</div>

<div (click)='$event.stopPropagation()' class='modal-footer'>
  <button (click)='activeModal.close(false); $event.stopPropagation()' class='btn btn-outline-secondary btn-sm'
          type='button'>
    {{ 'BUTTON.OK' | translate }}
  </button>
</div>

